module.exports = __webpack_public_path__ + "static/media/adding-bq.706f26bd.png";